export default "__VITE_ASSET__BBXmU8bx__ 480w, __VITE_ASSET__Qsbwah93__ 768w, __VITE_ASSET__9k1$JPo$__ 960w";